import { withRouter } from 'react-router-dom';

const TimeCharge = () => null;

export default withRouter(TimeCharge);
